// A constant list of Plugins related to the LogicFlows beta
export const logicFlowsPlugins = [
  'Json',
  'Effect',
  'Http',
  'Secret',
  'CMS',
  'Conditional',
  'Phone',
  'Email',
  'Color',
  'Link',
  'Video',
  'DateTime',
  'Form Logic',
  'Logic',
  'Collaborators',
  'UsersPlugin',
] as const;
